'use client';
import { Controller, get } from 'react-hook-form';
import { TextField } from '../../ui';

export interface InputProps {
  name: string;
  subName?: string;
  label: string;
  methods: any;
  type?: 'text' | 'password' | 'hidden' | 'email' | 'number';
  disabled?: boolean;
  focus?: boolean;
  placeholder?: string;
  required?: boolean;
}

export default function Input({
  name,
  label,
  methods,
  type = 'text',
  disabled = false,
  placeholder,
  required,
}: InputProps) {
  return (
    <Controller
      control={methods.control}
      name={name}
      render={({ field: { ref, ...field }, formState: { errors } }) => {
        const error = get(errors, name);

        return (
          <TextField
            {...field}
            ref={ref}
            helperText={error?.message}
            error={!!error}
            label={label}
            type={type}
            disabled={disabled}
            placeholder={placeholder}
            required={required}
          />
        );
      }}
      defaultValue=""
    />
  );
}
